import request from '@/utils/request'

export function getGoodsCoinList(data) {
  return request({
    url: 'api/v1/goods-sku/getCoinCfg',
    method: 'post',
    data: data
  })
}

export function getBoxCoinList(data) {
  return request({
    url: 'api/v1/goods-sku/getBoxCfg',
    method: 'post',
    data: data
  })
}

export function getGoodsSpinList(data) {
  return request({
    url: 'api/v1/goods-sku/getSpinCfg',
    method: 'post',
    data: data
  })
}

export function getDiamondSpinList(data) {
  return request({
    url: 'api/v1/goods-sku/getDiamondCfg',
    method: 'post',
    data: data
  })
}

export function exportGoodsSkuCfg(data) {
  return request({
    url: 'api/v1/goods-sku/export',
    method: 'post',
    data: data
  })
}

export function importGoodsSkuCfg(data) {
  return request({
    url: 'api/v1/goods-sku/import',
    method: 'post',
    data: data,
    timeout: 10000 * 5
  })
}

